import type { Dispatch, SetStateAction } from "react";
import { useCallback, useState } from "react";

export type IUseControlledValueProps<T> = {
  controlledValue?: T;
  controlledOnChange?: Dispatch<SetStateAction<T>>;
  defaultValue?: T;
};

export const useControlledValue = <T>({
  controlledValue,
  controlledOnChange,
  defaultValue,
}: IUseControlledValueProps<T>) => {
  const [uncontrolledValue, setUncontrolledValue] = useState<T | undefined>(
    defaultValue,
  );

  const uncontrolledOnChange: Dispatch<SetStateAction<T>> = useCallback(
    (action) => {
      setUncontrolledValue((prevValue) => {
        if (typeof action === "function") {
          return (action as (prevState: T) => T)(prevValue as T);
        }
        return action;
      });
    },
    [],
  );

  const value =
    controlledValue !== undefined ? controlledValue : uncontrolledValue;

  const onChange: Dispatch<SetStateAction<T>> =
    controlledOnChange !== undefined
      ? controlledOnChange
      : uncontrolledOnChange;

  return {
    value,
    onChange,
  };
};
